import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import I18n from '../../../config/i18n';
import Drive from './Drive';

export default class Drives extends React.Component {
  renderTitle() {
    return <div className="h4 mt3 mb1">{I18n.t('driveInventory')}</div>;
  }

  render() {
    const { shouldHideDriveTitle, errors } = this.props;
    return (
      <div>
        {!shouldHideDriveTitle && this.renderTitle()}
        <div className="h5">{I18n.t('driveInventoryMessage')}</div>
        <div className="mt2">
          <div className="clearfix">
            <div className="col col-3 h5 bold">{I18n.t('typeOfDrive')}</div>
            <div className="col col-3 h5 bold">{I18n.t('quantity')}</div>
          </div>
          {this.renderDrives()}
          <div
            className={cx('ui-error', { hide: !(errors && errors.self) })}
          ></div>
        </div>
      </div>
    );
  }

  renderDrives() {
    const { drives, driveTypes, errors } = this.props;
    return drives.map((drive, index) => {
      return (
        <Drive
          key={index}
          index={index}
          errors={errors && errors[index]}
          drive={drive}
          driveType={
            driveTypes && driveTypes[index] && driveTypes[index].driveType
          }
          onChange={this.props.onChange}
        />
      );
    });
  }
}

Drives.propTypes = {
  errors: PropTypes.any,
  drives: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
